// extracted by mini-css-extract-plugin
export var carrierNotice = "_lt-5";
export var carrierNoticePlaceholder = "_lt-6";
export var deliveryRow = "_lt-c";
export var fixedHeight = "_lt-4";
export var freightLogo = "_lt-b";
export var fullWidth = "_lt-3";
export var priceColumn = "_lt-7";
export var radioSelected = "_lt-9";
export var radioUnselected = "_lt-8";
export var selectedOption = "_lt-2";
export var selectedOptionContainer = "_lt-1";
export var selection = "_lt-0";
export var tallSkeletonText = "_lt-a";